import { Navigate, RouteObject } from "react-router";
import OffersRoute from "@/routes/processes/[processId]/vbs/offers/offers-route";
import { OfferRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/offer-route";
import { OfferDataRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/data/offer-data-route";
import { OfferTreatmentRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/treatment/offer-treatment-route";
import { OfferCalculationRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/calculation/offer-calculation-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/addresses-and-contacts/addresses-and-contacts-route";
import { OfferContractRoute } from "@/routes/processes/[processId]/vbs/offers/[offerId]/contract/offer-contract-route";

export const vbsOffersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OffersRoute />,
  },
  {
    path: ":offerId",
    element: <OfferRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <OfferDataRoute />,
      },
      {
        path: "contract",
        element: <OfferContractRoute />,
      },
      {
        path: "treatment",
        element: <OfferTreatmentRoute />,
      },
      {
        path: "calculation",
        element: <OfferCalculationRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
    ],
  },
];
